export default "__VITE_ASSET__DPYyj4FG__"